export default __webpack_public_path__ + "static/media/410.de6e9bbc.jpg";